import { useEffect, useState } from "react";
import { getPublicStats } from "../api/client";

/**
 * Real social-proof line — counts ready videos from the backend.
 * Hides itself entirely if the count is below threshold (avoids the
 * "this is a brand new product" tell of a tiny number) or if the
 * stats endpoint is unreachable.
 */
const HIDE_BELOW = 25;

export function SocialProof({ className = "" }: { className?: string }) {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    getPublicStats()
      .then(s => { if (!cancelled) setCount(s.videos_made); })
      .catch(() => { /* hide silently */ });
    return () => { cancelled = true; };
  }, []);

  if (count == null || count < HIDE_BELOW) return null;

  return (
    <p className={`text-xs uppercase tracking-widest text-neutral-500 ${className}`}>
      <span className="font-semibold text-neutral-700">
        {count.toLocaleString()}
      </span>{" "}
      memories brought back to life
    </p>
  );
}
